/**
 * Frontend feature contracts.
 *
 * Keep environment parsing and disabled-state routing here so every entry point
 * (routes, global navigation, and the authenticated sidebar) makes the same
 * decision. Feature flags are intentionally opt-in: only the exact string
 * `true` enables a dormant production surface.
 */
export function isEnabledFeatureFlag(value: unknown): boolean {
  return value === 'true';
}

export interface DocumentStudioFeatureContract {
  enabled: boolean;
  route: '/studio';
  disabledRedirect: '/home';
  documentsRedirect: '/studio' | '/home';
  legacyRedirect: '/studio' | '/home';
}

export function createDocumentStudioFeatureContract(
  rawFlag: unknown,
): Readonly<DocumentStudioFeatureContract> {
  const enabled = isEnabledFeatureFlag(rawFlag);
  const redirect = enabled ? '/studio' : '/home';

  return Object.freeze({
    enabled,
    route: '/studio',
    disabledRedirect: '/home',
    documentsRedirect: redirect,
    legacyRedirect: redirect,
  });
}

/**
 * Document Studio's backing service is retired. Re-enabling the frontend is a
 * deliberate production-build action and must use the exact `true` flag value.
 */
export const DOCUMENT_STUDIO = createDocumentStudioFeatureContract(
  import.meta.env.VITE_FEATURE_DOC_STUDIO,
);

export const DOC_STUDIO_ENABLED = DOCUMENT_STUDIO.enabled;
